// extracted by mini-css-extract-plugin
module.exports = {"root":"Status_root__UlPP_","approved":"Status_approved__2OwDs","rejected":"Status_rejected__1pTEE","expired":"Status_expired__2iLY0","label":"Status_label__1zMKx"};